export default __webpack_public_path__ + "static/media/news2402299.9a5d11d0.jpg";